<div class="huddle-suggestion-top-panel">
  <div class="tab-description">
    Track all suggestions with problem statements, recommendations, themes, products, and current status.
  </div>
  <div class="huddle-suggestion-control-panel">
    <div class="huddle-suggestion-left-control">
      <div *ngIf="managerHasMergeAccess" class="huddle-merge-suggestion-control">
        <div class="huddle-suggestion-checkbox-control" [class.active]="isMergSuggestionActive">
          <input type="checkbox" id="merge_suggestion" [checked]="isMergSuggestionActive" />
          <label for="merge_suggestion" (click)="toggleMergeSuggestion($event)">
            <img class="default-img" src="assets/images/checkbox-blank-circle-outline.svg" />
            <img class="active-img" src="assets/images/checkBox-circle-fill-svg.svg" />
            Merge Suggestions
          </label>
        </div>
        <div class="action-button-group" *ngIf="isMergSuggestionActive">
          <button class="action-button apply-btn" [disabled]="!isMergeButtonEnabled" (click)="proceedToMerge()">
            Proceed
          </button>
          <button class="action-button cancel-btn" (click)="cancelMerge()">
            Cancel
          </button>
        </div>
      </div>
      <!-- <p style="font-size: 16px">
        Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
        eirmod <br />ss
        tempor invidunt ut labore et dolore magna aliquyam erat, sed diam
        voluptua.
      </p> -->
    </div>
    <div class="huddle-suggestion-right-control">
      <div class="litmus-suggestion-filter-dd" #litmusfeedsearch id="litmusfeedsearch"
        *ngIf="isSearchEnabled && defaultSearchField">
        <div class="litmus-suggestion-filter-dd-input" [class.active]="showFilterFields">
          <img class="search-icon" src="assets/images/magnify.svg">
          <input type="text" (keyup)="searchByField($event)" [(ngModel)]="searchText" (click)="toggleSearchList()"
            [placeholder]="suggestionSearch.placeholder" />
          <button *ngIf="clearField.isEnabled" class="clear-button"
            (click)="getSuggestionforSelectedFields(clearField)">
            <img class="clear-img" src="assets/images/close.svg">
          </button>
          <button (click)="toggleFilterFieldList()" class="field-dropdown-button" [class.active]="showFilterFields">
            <img src="assets/images/menu-down-dark.svg" />
          </button>
        </div>
        <ul id="litmus-search-selector" *ngIf="isOptionLoading" class="litmus-suggestion-filter-dd-list">
          <li class="loader">
            <span class="circle-loader"></span> Just a moment.
          </li>
        </ul>
        <ul id="litmus-search-list" *ngIf="showSearchList && !isOptionLoading" class="litmus-suggestion-filter-dd-list">
          <li *ngFor="let item of searchResult.options" [class.disabled-message]="item.isError"
            (click)="getSuggestionforSelectedFields(item)">
            {{item.displayText || item.text}}
          </li>
        </ul>
        <ul id="litmus-search-selector" *ngIf="showFilterFields" class="litmus-suggestion-filter-dd-list">
          <li *ngFor="let item of searchableFieldList" (click)="changeFilterField(item)"
            [class.active]=" item.field_id == defaultSearchField.field_id">
            {{item.name}}
          </li>
        </ul>
      </div>
      <!-- Search Dropdown -->
      <div class="widget-container">
        <div class="download-button" (click)="suggestionResponseDownload()">
          <span ><img class="opacity" src="assets/images/download.svg"></span>
        </div>
       <!-- <div class="divider"></div>
        <div class="fullscreen-button" (click)="toggleFullScreen()" >
          <span ><img src="assets/images/fullscreen-exit.svg"></span>
        </div> -->
      </div>
      <div class="litmus-suggestion-paging">
        <button [disabled]="!pagingButtons.isFirst || !isDataLoaded" (click)="paginateFeedList('first')">
          <img src="assets/images/chevron-double-left.svg" />
        </button>
        <button [disabled]="!pagingButtons.isPrevious || !isDataLoaded" (click)="paginateFeedList('previous')">
          <img src="assets/images/chevron-left.svg" />
        </button>
        <span [class.disabled]="pagingDetails.total <= 0"> {{pagingDetails.start}} - {{pagingDetails.end}}
          of {{pagingDetails.total}} </span>
        <button [disabled]="!pagingButtons.isNext || !isDataLoaded" (click)="paginateFeedList('next')">
          <img src="assets/images/chevron-right.svg" />
        </button>
        <button [disabled]="!pagingButtons.isLast || !isDataLoaded" (click)="paginateFeedList('last')">
          <img src="assets/images/chevron-double-right.svg" />
        </button>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!isLoading && isSuggestionAvailble" class="table-holder">
  <app-overview-table *ngIf="!isLoading" [type]="'accordion'" [config]="tableConfigs" [columns]="suggestionTable.header"
    [fixedColumns]="suggestionTable.fixedHeader" (onDataSort)="getSortedData($event)" (onExapnd)="getChildEscalations($event)"
    (onCheck)="updateSelectSuggestion($event)" (onEdit)="editSuggestion($event)"
    [rows]="suggestionTable.rows"></app-overview-table>
  <!-- <app-ltms-data-table-v2 [data]="filteredSuggestionsData" [configs]="tableConfigs" (onChecked)="updateSelectSuggestion($event)" [columns]="columns">
  </app-ltms-data-table-v2> -->
</div>
<div *ngIf="!isLoading && !isSuggestionAvailble" class="table-holder">
  <app-ltms-error [code]="'404'"></app-ltms-error>
</div>

<div *ngIf="isLoading">
  <div class="d-flex align-items-center justify-content-center" style="min-height: 15rem">
    <div role="status">
      <app-ltms-loader></app-ltms-loader>
    </div>
  </div>
</div>
<suggestion-edit-modal [config]="modalDetail" (onClose)="closeEditModal()" (onCancel)="cancelMerge()"
  *ngIf="showEditModal"></suggestion-edit-modal>